export class UpdateAll {
	static readonly type = '[llc mortgage]update all transactions';
	constructor(public force: boolean) {}
}

export class UpdateStatus {
	static readonly type = '[llc mortgage]update transaction status';
	constructor(public transactionId: string) {}
}

export class LockUserAccess {
	static readonly type = '[llc mortgage] set user full access';
	constructor(public transactionId: string) {}
}

export class UnlockUserAccess {
	static readonly type = '[llc mortgage] clear user access';
	constructor(public transactionId: string) {}
}

export class UpdateTimestamp {
	static readonly type = '[llc mortgage] update access timestamp';
	constructor(public transactionId: string) {}
}
